const jobs = {
  reservations: 'Buchungen',

  moreActions: {
    clearBlacklistedDrivers: {
      title: 'Gesperrte Fahrer entfernen?',
      body: 'Dadurch werden etwaige gesperrte Fahrer aus den ausgewählten Buchungen und den zugehörigen Fahrten entfernt - bestehende Fahrerzuweisungen werden nicht verändert.',
      toastSuccess: 'Gesperrte Fahrer erfolgreich entfernt.',
    },
  },

  btnCreate: 'Erstellen',
  btnRoute: 'Route',

  createHeaderTitle: 'Erstellen',
  updateHeaderTitle: 'Aktualisieren',

  import: {
    title: 'Buchungen hochladen',
  },

  toast: {
    error: {
      create: {
        badResponse: 'Beim Erstellen der Buchung ist ein Fehler aufgetreten',
      },
      edit: {
        badResponse: 'Beim Aktualisieren der Buchung ist ein Fehler aufgetreten',
      },
      find: {
        badResponse: 'Could not find shuttles ',
      },
    },

    success: {
      create: {
        default: 'Die Buchung wurde erfolgreich erstellt',
      },

      update: {
        default: 'Buchung wurde erfolgreich aktualisiert',
      },
    },

    group: {
      success: 'Die Buchung wurde erfolgreich gruppiert',
      failure: {
        privateOnly: 'Wir konnten diese Buchungen nicht gruppieren, da einige davon nur als privat eingestellt sind.',
        unknownError: 'Beim Gruppieren dieser Buchungen ist ein unerwartetes Problem aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support.',
      },
    },

    ungroup: {
      success: 'Die Gruppierung der Buchung wurde erfolgreich aufgelöst.',
    },

    blockWaitAndReturn: {
      success: 'Die Buchung wurde erfolgreich vom Warten und Zurückkehren deaktiviert.',
    },

    unblockWaitAndReturn: {
      success: 'Die Buchung für Warte- und Rückfahrt wurde erfolgreich aktiviert.',
    },
  },

  toolTip: {
    routingCancelJob: 'Mindestens ein Job hat nicht den Status Neu',
    atLeastOneLockedJob: 'Mindestens ein Job ist gesperrt',
    noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    atLeastOneStatusNotNew: 'Mindestens ein Job hat nicht den Status Neu',
    dataSync: 'Die Datensynchronisierung läuft',
  },

  create: {
    confirmButtonText: 'Einreichen',
    successModal: {
      header: 'Erfolg',
      body: 'Buchung erstellt!',
    },

    errorModal: {
      header: 'Fehler aufgetreten',
      body: 'Buchung konnte nicht erstellt werden',
    },

    confirmationModal: {
      header: 'Buchung bestätigen',
      subtitle: 'Bitte lesen Sie das folgende Skript Wort für Wort durch. Überstürzen Sie nichts!!!',
      content:
        'We have {{service}} booking for {{seats}} person\nOn {{date}} from {{from}} to {{to}}\n\nIs That correct? Great!\n\nPrice is ${{price}}\nThank you for calling {{company}}',
      table: {
        headers: {
          details: 'Fahrtdetails',
          fare: 'Tarif',
        },

        fields: {
          details: {
            pickAdrs: 'Abholadresse',
            dropAdrs: 'Zieladresse',
            pickTime: 'Abholzeit',
            seats: 'Erwachsene',
          },
          fare: {
            service: 'Dienst',
          },
        },
      },
      bottomLine: 'Gesamtpreis',
    },
    serviceTable: {
      columns: {
        name: 'Name',
        maxPax: 'Max. Personenzahl',
      },
    },
    duplicateJobsModal: {
      body: 'do you want to proceed?,Bitte beachten Sie, dass es andere Buchungen mit genau denselben Details gibt. Möchten Sie fortfahren?, do you want to proceed?',
      btnConfirm: 'Ja',
      btnClose: 'Nein',
    },
  },

  payments: {
    table: {
      headers: {
        createdBy: 'Erstellt',
        email: 'E-Mail des Absenders',
        amount: 'Anzahl',
        type: 'Typ',
        ccMasked: 'CC maskiert',
        status: 'Status',
        refNum: 'Ref Num ',
      },
    },

    paymentsDetails: {
      title: 'Details',

      status: {
        charged: 'Aufgeladen:',
        pending: 'Ausstehend:',
        declined: 'Abgelehnt:',
        variance: 'Varianz:',
      },
    },

    addPaymentForm: {
      title: 'Zahlung hinzufügen',

      fields: {
        amount: 'Anzahl',
        paymentType: 'Bezahlarten',
        cardNum: 'Kreditkartennummer',
        cardExp: 'Läuft ab',
        cvv: 'CVV',
        paymentOptions: {
          select: 'Wählen',
          credit: 'Kreditkarte',
          directBill: 'Direktrechnung',
          card: 'Karte',
          expDate: 'Ablaufdatum',
        },
      },

      validations: {
        price: 'Der Preis muss größer als Null sein',
      },

      confirmPaymentBtn: 'Zahlung bestätigen',
      modalSuccess: {
        header: 'Erfolg!',
        body: 'Zahlung erfolgreich!',
      },

      modalError: {
        header: 'Es ist ein Fehler aufgetreten!',
        body: 'Please Try Again,Zahlung fehlgeschlagen, bitte versuchen Sie es erneut, Please Try Again',
      },
    },
  },

  update: {
    title: 'Buchungsnummer {{id}}',
    confirmButtonText: 'Einreichen',

    successModal: {
      header: 'Erfolg',
      body: 'Buchung aktualisiert!',
    },

    errorModal: {
      header: 'Fehler aufgetreten',
      body: 'Buchung konnte nicht aktualisiert werden',
    },

    formTabs: {
      summary: 'Zusammenfassung',
      edit: 'Bearbeiten',
      payments: 'Zahlungen',
      notes: 'Hinweise',
      history: 'Geschichte',
    },

    summary: {
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      tripId: 'Fahrt-ID',
      tripStatus: 'Fahrtstatus',
      RPTime: 'Gewünschte Abholzeit',
      MPTime: 'Moovex Abholzeit',
      PETA: 'Voraussichtliche Ankunftszeit bei Abholung',
      PR: 'Abholung gemeldet (Fahrer)',
      DR: 'Gemeldete Abgabe (Fahrer)',
      empty: 'Nicht verfügbar',
      notAssigned: 'Nicht zugewiesen',
      notRouted: 'Nicht weitergeleitet',
      attributes: 'Eigenschaften',
      noShow: 'Nichterscheinen',
      supplier: 'Anbieter', 
    },
    jobNotSupported: 'Buchungstyp wird nicht unterstützt',
  },

  bulk: {
    select: 'Wählen',
    toasts: {
      createdSuccessfully: 'Buchung erstellt!',
    },

    errorModal: {
      header: 'Fehler aufgetreten',
      body: 'Buchung konnte nicht erstellt werden',
    },

    table: {
      direction: {
        to: 'Verteilen',
        from: 'Sammeln',
        both: 'Sammeln & Verteilen',
      },
    },

    direction: {
      label: 'Richtung',
      to: 'Bis',
      from: 'Von',
      both: 'Beide',
    },

    dateMode: {
      automated: 'Automatisierte Planung',
      manual: 'Manuelle Zeitauswahl',
    },

    form: {
      information: {
        details: {
          header: 'Buchungsinformationen',
          messageDublication: 'Karte mit den gleichen Werten ist bereits vorhanden',
          fields: {
            shift: 'Schicht',
            from: 'Von',
            to: 'Bis',
            fromDate: 'Von Datum',
            toDate: 'Bis Datum',
            weekDays: 'Wochentage',
            fromHour: 'Von Stunde',
            toHour: 'Bis Stunde',
            requestPickup: 'Gewünschte Abholzeit',
            requestDropoff: 'Gewünschte Ausstiegszeit',
            direction: 'Richtung auswählen',
            dateMode: 'Zeitpräferenz',
            btnAddDetails: ',+ Zusätzliche Optionen hinzufügen',
            btnRemoveDetails: 'Entfernen',
          },
        },
        locations: {
          header: 'Standorte',
          fields: {
            locations: 'Standort auswählen',
          },
        },
        dateMode: {
          header: 'Zeitpräferenz',
          label: 'Wählen Sie die gewünschte Zeit',
        },
      },
    },
  },

  routeSummary: {
    reservations: 'Buchungen',
    trips: 'Fahrten',
    assigned: 'Zugewiesen',
    unassigned: 'Nicht zugewiesen',
    tripsAssigned: 'Zugewiesene Fahrten',
    vehicles: 'Fahrzeuge',
    workingTime: 'Arbeitszeit',
    drivingTime: 'Fahrzeit',
    miles: 'Meilen',
    routingProcessTime: 'Routing-Prozesszeit',
  },

  headerButtons: {
    create: {
      new: 'Neu',
      quick: 'Schnell',
      bulk: 'Menge',
      shuttle: 'Shuttle',
      import: 'Importieren',
      normal: 'Normal',
      schoolBooking: 'Schulbuchung',
      workplaceBooking: 'Arbeitsplatzbuchung',
    },

    import: 'Importieren',

    route: {
      route: 'Route',
      routeAndAssign: 'Weiterleiten und Zuweisen',
    },

    moreActions: {
      button: 'Mehr',
      options: {
        cancelModal: {
          title: 'Buchungen stornieren',
          reasonInputPlaceholder: 'Bitte geben Sie einen Grund für die Stornierung ein.',
          contentSingular: 'Sie sind dabei, eine Buchung zu stornieren.',
          contentPlural: 'Sie sind dabei, {{count}} Buchungen zu stornieren.',
          confirmButton: 'Bestätigen',
          success: 'Buchungen wurden erfolgreich storniert',
        },
        deleteModal: {
          title: 'Buchungen löschen',
          body: 'Sie sind dabei, {{count}} Buchungen zu löschen',
          success: 'Buchungen wurden erfolgreich gelöscht',
        },
        releaseRouting: {
          label: 'Freigaberouting',
        },
        manualRouteModal: {
          title: 'Manuelle Route',
          toolTip: {
            header: 'Ordnen Sie Ihre ausgewählten Buchungen per Drag & Drop in der gewünschten Fahrtreihenfolge an',
          },
          removeModal: {
            title: 'Buchung entfernen',
            body: 'Sie sind dabei, eine Buchung zu entfernen.',
            confirmButton: 'Bestätigen',
          },
          durationExceeds: {
            title: 'Die Fahrtdauer überschreitet 24 Stunden',
            body: 'Die Fahrtdauer, die Sie planen, enthält Buchungen mit einem Zeitunterschied von mehr als 24 Stunden. Möchten Sie wirklich fortfahren?',
            confirmButton: 'Bestätigen',
          },
        },
      },
    },
  },

  advancedRoutingModal: {
    all: 'Alle',
    RouteBodyText: 'Sie sind dabei, {{num}} Buchungen weiterzuleiten.',
    RouteAssignBodyText: 'Sie sind dabei, {{num}} Buchungen weiterzuleiten und zuzuweisen.',
    advancedSettings: 'Fortschrittlich',
    noJoin: 'Kein Beitritt',
    joinOptions: {
      noJoin: 'Kein Beitritt',
      tryJoin: 'Versuchen Sie es',
      onlyJoin: 'Nur beitreten',
    },
    clusterSettings: 'Cluster-Einstellungen',
    assignSettings: 'Einstellungen für die Fahrerzuweisung',
    routeJobs: 'Streckenbuchungen',
    routeAssignJobs: 'Buchungen weiterleiten und zuweisen',
    advancedRoutingSettings: 'Erweiterte Routing-Einstellungen',
    mainParameters: 'Routeneinstellungen',
    ratio: 'Verhältnis',
    ratioInfo:
      '1,5 bedeutet, dass die Verweildauer einer Person im Fahrzeug 150 % der Zeit, die sie alleine beim Fahren verbracht hätte, nicht überschreitet.',
    pax: 'Max. Passagiere',
    paxInfo: 'Maximale Anzahl Sitzplätze pro Fahrt',
    maxDuration: 'Maximale Dauer',
    maxDurationInfo: 'Maximale Dauer einer Fahrt',
    maxStops: 'Max. Stopps',
    maxStopsInfo: 'Maximale Stopps pro Fahrt',
    pickSeconds: 'Einstiegszeit',
    pickSecondsInfo:
      'Calculated boarding time of the job. total duration of the trip will be prolonged. times will be added to the "wait" array for this stop.',
    dropSeconds: 'Ausstiegszeit',
    dropSecondsInfo:
      'Calculated drop-off time of the job. total duration of the trip will be prolonged. times will be added to the "wait" array for this stop.',
    pickGapAfter: 'Max. spät',
    pickGapAfterInfo: 'Die Abholzeit eines Auftrags darf nicht mehr als 30 Minuten nach der Abholzeit eines anderen Auftrags liegen.',
    pickGapBefore: 'Max. früh',
    pickGapBeforeInfo: 'Die Abholzeit eines Auftrags darf der Abholzeit eines anderen Auftrags um nicht mehr als 30 Minuten vorausgehen.',
    airKMPH: 'Luft km/h',
    airKMPHInfo: 'Support kontaktieren',
    allowLate: 'Verspätung zulassen',
    allowLateInfo: 'Support kontaktieren',
    maxPrice: 'Höchstpreis',
    maxPriceInfo: 'Support kontaktieren',
    maxTrips: 'Max. Fahrten',
    maxTripsInfo: 'Max. Fahrunterstützung',
    shiftMaxMinutes: 'Schicht Max. Minuten',
    shiftMaxMinutesInfo: 'Support kontaktieren',

    routeTemplates: 'Routenvorlagen',
    assignTemplates: 'Vorlagen zuweisen',

    form: {
      validation: {
        mustBeHigher: 'Muss {{val}} oder höher sein',
      },
    },
  },

  clusters: {
    clusterRadius: 'Cluster Diameter',
    snapTo: 'Modus',
    none: 'Niemand',
    both: 'Beide',
    to: 'Bis',
    from: 'Von',
    address: 'Adresse',
    bus: 'Bushaltestelle',
  },

  forms: {
    header: {
      createNewRservationTitle: 'Neue Buchung',
      updateReservationTitle: 'Buchung',

      createNormalRservation: {
        subTitle: 'Normal',
      },

      createQuickRservation: {
        subTitle: 'Schnell',
      },

      createShuttleRservation: {
        subTitle: 'Shuttle',
      },
    },
    roundTrip: 'Rundfahrt',
    oneWay: 'Ein Weg',
    information: {
      details: {
        header: 'Profildetails',
        fields: {
          site: 'Bereich',
          profile: 'Profil',
        },
      },
      jobDetails: {
        flightTypes: {
          international: 'International',
          domestic: 'Inländisch',
          customerRequest: 'Kundenanfrage',
        },
        fareBreakdown: 'Tarifaufschlüsselung',
      },
      linkedPassengers: {
        header: 'Verknüpfte Fahrgäste',
        searchPlaceholder: 'Suchen',
      },
      reservationDetails: {
        header: 'Buchungsdetails',
        fields: {
          from: 'Von',
          to: 'Bis',
          terminal: 'Terminal',
          seats: 'Sitzplätze',
          checkedBags: 'Aufgegebenes Gepäck',
          switchADA: 'ADA',
          wheelchair: 'Rollstuhl',
          adults: 'Erwachsene',
          infants: 'Kleinkinder',
          carryon: 'Handgepäck',
        },
        clearBtn: 'Löschen',
      },
      flightDetails: {
        header: 'Fluginformationen',
        flightAirline: 'Fluggesellschaft',
        flightNumber: 'Flugnummer',
        scheduledFlightTime: 'Geplante Flugzeit',
        actualFlightTime: 'Tatsächliche Flugzeit',
        flightStatus: 'Flugstatus',
      },
      caregiverInformation: {
        header: 'Informationen zur Pflegekraft',
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          address: 'Adresse',
          phone: 'Telefon',
        },
      },
      serviceAndTime: {
        header: 'Service und Zeit',
        fields: {
          scheduleBy: 'Planen nach',
          dateTime: 'Datum und Uhrzeit',
          service: 'Dienst',
          switchRecurring: 'Wiederkehrend',
          attributes: 'Eigenschaften',
          repeatEvery: 'Alle wiederholen',
          ends: 'Ende',
          never: 'Niemals',
          on: 'An',
          after: 'Nach',
          occurrences: 'Vorkommen',
        },
        buttons: {
          now: 'Jetzt',
        },
      },
      personalInfo: {
        header: 'Persönliche Informationen',
        fields: {
          email: 'E-Mail',
          fullName: 'Vollständiger Name',
          firstName: 'Vorname',
          lastName: 'Nachname',
          phone: 'Telefon',
          address: 'Adresse',
          specialIdentifier: 'Spezielle Kennung',
        },
      },
      billingInfo: {
        sameAsPersonalInformation: 'Dasselbe wie persönliche Informationen',
        header: 'Rechnungsdaten',
        fields: {
          country: 'Land',
          state: 'Staat',
          zip: 'PLZ',
        },
      },
      payments: {
        header: 'Zahlungen',
        fields: {
          price: 'Preis',
          paymentSelect: {
            header: 'Bezahlarten',
            options: {
              credit: 'Kreditkarte',
              directBill: 'Direktrechnung',
            },
          },
          cardNum: 'Kreditkartennummer',
          cardExp: 'Läuft ab',
          cvv: 'CVV',
        },
      },
      additionalFields: {
        header: 'Zusätzliche Felder',
        fields: {
          driver: 'Fahrer',
          car: 'Auto',
          waitMinutes: 'Warteminuten',
        },
      },
      notes: {
        header: 'Hinweise',
      },
      profile: {
        header: 'Profil',
        label: 'Profil auswählen',
      },
      passengers: {
        header: 'Persönliche Informationen',
        label: 'Fahrgäste auswählen',
      },
      attributes: {
        header: 'Eigenschaften',
        label: 'Eigenschaften auswählen',
      },
      supplier: {
        header: 'Anbieter'
      }
    },
    validations: {
      unit: {
        required: 'Profil ist erforderlich',
      },
      amount: {
        required: 'Betrag ist erforderlich',
      },
      from: {
        required: 'Von ist erforderlich',
      },
      direction: {
        required: 'Richtung ist erforderlich',
      },
      to: {
        required: 'Bis ist erforderlich',
      },
      type: {
        required: 'Erforderlich',
      },
      email: {
        message: 'Geben Sie eine gültige E-Mail-Adresse ein',
        required: 'E-Mail ist erforderlich',
      },
      firstName: {
        conditions: {
          min: 'Der Vorname muss mindestens 2 Zeichen lang sein.',
          max: 'Der Vorname darf maximal 30 Zeichen lang sein.',
        },
        required: 'Vorname ist erforderlich',
      },
      lastName: {
        conditions: {
          min: 'Der Nachname muss mindestens 2 Zeichen lang sein.',
          max: 'Der Nachname darf maximal 30 Zeichen lang sein.',
        },
        required: 'Nachname ist erforderlich',
      },
      phone: {
        message: 'Die Telefonnummer ist ungültig.',
        required: 'Telefonnummer ist erforderlich',
      },
      price: {
        message: 'Der Preis muss eine Zahl sein',
        required: 'Preis ist erforderlich',
      },
      flightTerminal: {
        required: 'Flugterminal ist erforderlich',
      },
      adults: {
        required: 'Erwachsene sind erforderlich',
      },
      seats: {
        required: 'Sitzplätze sind erforderlich',
      },
      infants: {
        required: 'Kleinkinder sind erforderlich',
      },
      carryon: {
        required: 'Handgepäck ist erforderlich',
      },
      paymentType: {
        required: 'Zahlungsart ist erforderlich',
      },
      cardNum: {
        required: 'Kartennummer ist erforderlich',
      },
      cardExp: {
        required: 'Kartenablaufdatum ist erforderlich',
      },
      cvv: {
        required: 'CVV ist erforderlich',
      },
      profile: {
        required: 'Profil ist erforderlich',
      },
      fare: {
        required: 'Fahrpreis ist erforderlich',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
        delete: 'Löschen',
      },
    },
  },

  table: {
    footer: {
      totalSeats: 'Gesamtzahl der Sitzplätze: {{seats}}',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
      route: 'Route',
      cancel: 'Stornieren',
      routeAndAssign: 'Weiterleiten und Zuweisen',
      group: 'Gruppe',
      ungroup: 'Gruppierung aufheben',
      blockWaitAndReturn: 'Deaktivieren Sie Warten und Zurückgeben',
      unblockWaitAndReturn: 'Warten und Zurückgeben aktivieren',
      manualRoute: 'Manuelle Route',
      clearBlacklistedDrivers: 'Gesperrte Fahrer entfernen',
      releaseRouting: 'Freigaberouting',
      sendToBid: 'Zum Bieten senden',
      estimateWillCalls: 'Estimate Will Calls',
      tooltips: {
        estimateWillCallsDisabled: 'Mindestens ein Job hat nicht den Status Neu'
      }
    },
    cells: {
      car: {
        none: 'Keine Fahrzeuge',
      },
      driver: {
        none: 'Kein Fahrer',
      },
      supplier: {
        none: 'Kein Anbieter'
      }, 
    },
    filters: {
      status: 'Status',
      profile: 'Profil',
      supplier: 'Anbieter',
      attributes: 'Eigenschaften',
      flightNumber: 'Flugnummer',
      airline: 'Fluggesellschaft',
      flightStatus: 'Flugstatus',
      drivers: 'Fahrer',
      vehicles: 'Fahrzeuge',
      from: 'Von',
      to: 'Bis',
      locations: 'Standardstandorte',
      airportLocations: 'Flughafenstandorte',
      indicators: 'Indikatoren',
      areas: 'Zonen',
    },
    headers: {
      externalID: 'Externe ID',
      flightInfo: 'Fluginformationen',
      id: 'Ausweis',
      io: 'I&O',
      returnTrip: 'Rückfahrt',
      legA: 'Etappe A',
      legB: 'Etappe B',
      seats: 'Sitzplätze',
      driver: 'Fahrer',
      vehicle: 'Fahrzeug',
      from: 'Von',
      to: 'Bis',
      supplier: 'Anbieter',
      statusAndId: 'Ausweis',
      passenger: 'Fahrgast',
      indicators: 'Indikatoren',
      attributes: 'Eigenschaften',
      extendUntilDate: 'Warten bis',
      date: 'Datum',
      phone: 'Telefon',
      flightNumber: 'Flugnummer',
      email: 'E-Mail',
      service: 'Dienst',
      airline: 'Fluggesellschaft',
      scheduledFlightTime: 'Geplante Flugzeit',
      actualFlightTime: 'Tatsächliche Flugzeit',
      flightStatus: 'Flugstatus',
      price: 'Preis',
      profile: 'Profil',
      areas: 'Zonen',
      distance: 'Distanz',
      duration: 'Dauer',
    },
    statuses: {
      new: 'Neu',
      onHold: 'In der Warteschleife',
      canceled: 'Storniert',
      routing: 'Routenplanung',
      routed: 'Geroutet',
      picked: 'Ausgewählt',
      dropped: 'Abgesetzt',
      noshow: 'Nichterscheinen',
    },
    indicators: {
      grouped: 'Gruppiert',
      waitReturn: 'Warten & Zurückkehren',
      twoWay: 'Zweiwege',
      dateTypeDrop: 'Ankunftszeit',
    },
    labels: {
      grouped: 'Gruppiert',
      waitAndReturn: 'Warten und zurückkehren',
      roundTrip: 'Zweiwege',
      arrivalTime: {
        label: 'Ankunftszeit',
        tooltip: 'Ankunftszeit',
      },
    },
  },

  assignVehiclesDrivers: {
    routeSummaryModal: {
      header: 'Routenübersicht',
    },
  },
  checkRouteStatus: {
    routeSummaryModal: {
      header: 'Routenübersicht',
    },
  },
  shuttleReservation: {
    create: {
      confirmButtonText: 'Buchen',
    },

    form: {
      information: {
        recurring: {
          header: 'Wiederkehrend',
        },
        personalInformation: {
          header: 'Persönliche Daten',
          fields: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon',
          },
        },
        paymentOption: {
          header: 'Zahlungsmöglichkeiten',
          fields: {
            paymentType: 'Bezahlarten',
            cardNum: 'Kartennummer',
            cardExp: 'Läuft ab',
            cvv: 'CVV',
            rate: 'Rate',
            amount: 'Anzahl',
            fare: 'Tarif',
          },
          paymentTypes: {
            free: 'Frei',
            opuscard: 'OPUS-Karte',
            cashonboard: 'Bargeld an Bord',
            creditcard: 'Kreditkarte',
            correspondance: 'Korrespondenz',
          },
          rateTypes: {
            ordinary: 'Bargeldbetrag',
            reduced: 'Reduziert',
          },
        },
        bookingDetails: {
          header: 'Buchungsdetails',
          fields: {
            supplier: 'Anbieter',
            date: 'Datum',
            hour: 'Stunde',
            area: 'Zone',
            direction: 'Richtung',
            operationHours: 'Öffnungszeiten',
            line: 'Shuttle',
            pickup: 'Abholen',
            dropoff: 'Ausstieg',
            seats: 'Sitzplätze',
          },
        },
      },
      validations: {
        drivers: {
          required: 'Fahrer sind erforderlich',
        },
        area: {
          required: 'Zone ist erforderlich',
        },
        direction: {
          required: 'Richtung ist erforderlich',
        },
        unit: {
          required: 'Einheit ist erforderlich',
        },
        supplier: {
          required: 'Anbieter ist erforderlich',
        },
        driver: {
          required: 'Fahrer ist erforderlich',
        },
        start: {
          required: 'Startdatum ist erforderlich',
        },
        end: {
          required: 'Enddatum ist erforderlich',
        },
        firstName: {
          required: 'Vorname ist erforderlich',
        },
        lastName: {
          required: 'Nachname ist erforderlich',
        },
        email: {
          required: 'E-Mail ist erforderlich',
        },
        phone: {
          required: 'Telefon ist erforderlich',
        },
        date: {
          required: 'Datum ist erforderlich',
        },
        line: {
          required: 'Shuttle ist erforderlich',
        },
        hour: {
          required: 'Stunde ist erforderlich',
        },
        from: {
          required: 'Von ist erforderlich',
        },
        fromLat: {
          required: 'Von Breitengrad ist erforderlich',
        },
        fromLon: {
          required: 'Von Längengrad ist erforderlich',
        },
        to: {
          required: 'Bis ist erforderlich',
        },
        toLat: {
          required: 'Bis Breitengrad ist erforderlich',
        },
        toLon: {
          required: 'Bis Breitengrad ist erforderlich',
        },
        seats: {
          required: 'Sitzplätze sind erforderlich',
          conditions: {
            min: 'Sitze sollten höher sein als {{min}}',
          },
        },
        paymentOptions: {
          required: 'Zahlungsoptionen sind erforderlich',
          paymentType: {
            required: 'Zahlungsart ist erforderlich',
          },
          data: {
            required: 'Zahlungsdaten sind erforderlich',
            opusCard: {
              minLength: 'Muss genau 12 Zeichen lang sein',
            },
          },
        },
      },
    },

    toasts: {
      notFound: 'Shuttle für diesen Tag nicht gefunden!',
    },
  },
  duplicatedCreationModal: {
    header: 'Doppelte Buchung: Fortfahren?',
    body: 'Es gibt weitere Buchungen mit identischen Angaben. Möchten Sie mit der Erstellung der Buchung fortfahren?',
  },
  duplicatedUpdatingModal: {
    header: 'Doppelte Buchung: Fortfahren?',
    body: 'Es gibt weitere Buchungen mit identischen Angaben. Möchten Sie mit der Aktualisierung der Buchung fortfahren?',
  },
  modals: {
    groupModal: {
      header: 'Gruppenbuchungen',
      body: 'Sie sind dabei, {{count}} Buchungen zu gruppieren',
      btnConfirm: 'Bestätigen',
    },
    confirmGroupModal: {
      header: 'Gruppenbuchungen',
      body: 'Eine der Buchungen wurde bereits gruppiert. Möchten Sie fortfahren und sie neu gruppieren?',
    },
    unGroupModal: {
      header: 'Gruppierung von Buchungen aufheben',
      body: 'Sie sind dabei, die Gruppierung von {{count}} Buchungen aufzuheben',
      btnConfirm: 'Bestätigen',
    },
    blockedGroupModal: {
      header: 'Gruppieren/Aufhebung der Gruppenbuchungen',
      body: 'Group/Ungroup action is only allowed on bookings with a "Neu" status',
      btnConfirm: 'Schließen',
    },
  },
};

export default jobs;
